export interface IRuleResult {
  RuleCategory: string;
  RuleName: string;
  RuleText: string;
  Strictness: RuleStrictness;
  SortOrder: number;
  IsValid: boolean;
  AdditionalInformation: string;
  ActionName: string;
  Reason: string;
}

export enum RuleStrictness {
  NotApplicable = 10,
  Warning = 20,
  Regular = 30,
  Mandatory = 40
}

export enum ComplianceStatus {
  Compliant = 1,
  Warning = 2,
  NonCompliant = 3
}

export interface IRuleCategory {
  Id: string;
  EntityType: string;
  RuleCategoryName: string;
  RuleCategoryText: string;
  SortOrder: number;
}

export interface IRuleGroup {
  category: string;
  length: number;
  rules: Array<IRuleResult>;
  groupCompliance: ComplianceStatus,
  compliantCount: number;
  nonCompliantCount: number;
  warningCount: number;
}

export interface IChecklistRefreshedEvent {
  nonCompliantCount: number;
}